import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListingLibEmptyStateCell() {
  return /*#__PURE__*/_jsx("span", {
    "aria-label": I18n.text('frameworkListingLib.cells.emptyCell.noData'),
    children: "--"
  });
}